"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.h5AndroidbridgeInit = void 0;
var h5BridgeReadyPromise;
var h5AndroidbridgeInit = function () {
    if (!h5BridgeReadyPromise) {
        h5BridgeReadyPromise = new Promise(function (resolve, reject) {
            var run = function () {
                try {
                    window.WebViewJavascriptBridgeAndroid = window.nuva && window.nuva.require();
                    resolve({});
                }
                catch (e) {
                    reject(e);
                }
            };
            // 为了兼容旧版本，增加判断win.nuva.isReady === undefined
            if (window.nuva && (window.nuva.isReady === undefined || window.nuva.isReady)) {
                run();
            }
            else {
                document.addEventListener('runtimeready', function () {
                    run();
                }, false);
                // 捕获 nuvajs bootstrap 启动失败, 增加一个 runtime error 事件监听
                // SEE: https://work.aone.alibaba-inc.com/issue/29105600
                // SEE: https://code.aone.alibaba-inc.com/dingding/nuvajs/codereview/3324234
                document.addEventListener('runtimefailed', function (e) {
                    // 低于 4.4 的安卓不支持 initCustomEvent 无法补充信息到自定义事件
                    var detail = (e && e.detail) || { errorCode: '2', errorMessage: 'unknown nuvajs bootstrap error' };
                    reject(detail);
                }, false);
            }
        });
    }
    return h5BridgeReadyPromise;
};
exports.h5AndroidbridgeInit = h5AndroidbridgeInit;
var h5AndroidBridge = function (method, params) {
    if (!h5BridgeReadyPromise) {
        h5BridgeReadyPromise = exports.h5AndroidbridgeInit();
    }
    return h5BridgeReadyPromise.then(function () {
        return new Promise(function (resolve, reject) {
            var arr = method.split('.');
            var suff = arr.pop() || '';
            var pre = arr.join('.');
            var success = function (data) {
                if (typeof params.onSuccess === 'function') {
                    params.onSuccess(data);
                }
                resolve(data);
            };
            var fail = function (err) {
                if (typeof params.onFail === 'function') {
                    params.onFail(err);
                }
                reject(err);
            };
            if (typeof window.WebViewJavascriptBridgeAndroid === 'function') {
                window.WebViewJavascriptBridgeAndroid(success, fail, pre, suff, params);
            }
        });
    });
};
exports.default = h5AndroidBridge;
